import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import 'element-plus/dist/index.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/styles/global.scss'

const app = createApp(App)

// 添加切换语言的方法
app.config.globalProperties.$changeLanguage = (lang) => {
  i18n.global.locale = lang; // 切换语言
//   console.log(i18n.global.messages[lang].products); // 检查新语言的 products 数据
};

app.use(store)
   .use(router)   
   .use(i18n)  // 确保这行在 mount 之前
   .mount('#app')
